var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTiktok(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M 15.61 3 C 15.608 4.465 16.365 5.827 17.61 6.6 C 18.3 7.05 19.12 7.3 20 7.3 L 20 10.4 C 18.429 10.405 16.896 9.923 15.61 9.02 L 15.61 15.3 C 15.61 18.44 13.01 21 9.81 21 C 8.621 21.003 7.46 20.644 6.48 19.97 C 4.932 18.919 4.004 17.171 4 15.3 C 4.036 11.813 7.139 9.157 10.59 9.66 L 10.59 12.82 C 8.903 12.281 7.177 13.53 7.16 15.3 C 7.16 16.3 7.73 17.17 8.58 17.6 C 8.94 17.8 9.36 17.9 9.81 17.9 C 11.23 17.9 12.4 16.8 12.45 15.4 L 12.45 3 L 15.61 3 Z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiktok);
export default __webpack_public_path__ + "static/media/tiktok.65479c2d7b60171c36811f834d852e1e.svg";
export { ForwardRef as ReactComponent };